<template>
    <div class="flex">
        <ButtonCircle :disabled="disabled" @click="rotateLeft" title="Rotate left">
            <i class="icon-ccw"></i>
        </ButtonCircle>
        <ButtonCircle :disabled="disabled" @click="rotateRight" title="Rotate right">
            <i class="icon-ccw icon-revers"></i>
        </ButtonCircle>

        <div class="v-divider"></div>

        <form class="flex" :class="{disabled}" @submit.prevent="setAngleFromInput">
            Angle: <input :disabled="disabled" type="text" v-model="inputAngle">
            <ButtonCircle :disabled="disabled" type="submit" title="Rotate on angle">
                <i class="icon-ccw-1"></i>
            </ButtonCircle>
        </form>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import ButtonCircle from "../../components/ButtonCircle";

    export default {
        name: "RotateTrim",

        components: {
            ButtonCircle
        },

        props: [
            'defaultAngle',
            'disabled',
        ],

        data() {
            return {
                inputAngle: 0,
            }
        },

        methods: {
            ...mapActions('angles', [
                'rotateTrim',
            ]),

            rotateLeft() {
                const angle = -this.defaultAngle;

                this.rotateTrim(angle);
            },

            rotateRight() {
                const angle = this.defaultAngle;

                this.rotateTrim(angle);
            },

            setAngleFromInput() {
                const angle = +this.inputAngle;

                if (!angle || this.disabled) return;

                this.rotateTrim(angle);

                // reset local value
                this.inputAngle = 0;
            },

        },

    }
</script>

<style scoped>
    button {
        margin: 0 5px;
    }

    form {
        display: flex;
        align-items: center;
        margin: 0 0 0 5px;
    }

    input {
        width: 35px;
        margin: 0 5px 0 3px;
    }

    .v-divider {
        height: 100%;
        margin: 0 5px;
        border-left: 1px solid #ddd;
    }
</style>